import { createApp, type Plugin } from 'vue';

import App from './App.vue';

import './style.css';
import 'splitpanes/dist/splitpanes.css';
import '@next-market-map-api/marketmap/style.css';

const app = createApp(App);

// Install all plugins inside the `plugins` folder
Object.values<Plugin>(import.meta.glob('./plugins/*.ts', { eager: true })).map(
  (plugin) => plugin.install?.(app)
);

app.mount('#app');
